<template>
  <v-app>
    <nav style="z-index: 3">
      <v-toolbar color="#6CC8A0" style="height: 70px" elevation="0">
        <v-img
          alt="Seed Logo"
          class="shrink app jarvizLogo"
          contain
          :src="images.logo"
          transition="scale-transition"
          width="140"
          height="58"
          style="margin-left: -40px"
        />
        <v-app-bar-nav-icon
          class="white--text appBarNavIcon hidden-lg-and-up"
          @click.stop="drawer = !drawer"
          style="margin-left: -40px"
        ></v-app-bar-nav-icon>

        <v-spacer></v-spacer>
        <v-menu offset-y :nudge-bottom="10" v-if="false">
          <template v-slot:activator="{ on: menu }">
            <v-avatar size="30px" v-on="{ ...menu }" class="mr-4 v-button">
              <img
                alt
                :src="require(`@/assets/imgs/${currentflag}.png`)"
                style="width: 24px; height: 24px"
              />
            </v-avatar>
          </template>
          <v-list>
            <v-list-item
              v-for="entry in languages"
              :key="entry.title"
              @click="
                changeLocale(
                  entry.language,
                  entry.flag,
                  entry.title,
                  entry.highlighted
                )
              "
            >
              <v-list-item-action>
                <img
                  alt
                  :src="require(`@/assets/imgs/${entry.flag}.png`)"
                  style="width: 24px; height: 24px"
                />
              </v-list-item-action>
              <v-list-item-title>{{ entry.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-menu offset-y :nudge-bottom="10">
          <template v-slot:activator="{ on: menu }">
            <v-btn
              text
              v-on="{ ...menu }"
              @click="logout"
              style="text-transform: capitalize; text-transform: none"
            >
              <img alt src="@/assets/imgs/Group 2831.png" />
            </v-btn>
          </template>
        </v-menu>
      </v-toolbar>

      <v-navigation-drawer
        elevation="0"
        fixed
        app
        style="height: 100%; margin-top: 70px; width: 290px"
        v-model="drawer"
        value="true"
        absolute
      >
        <v-layout row="wrap" justify-center mt-5 pt-4>
          <!-- demo delete later -->
          <v-avatar align="center" size="90">
            <!-- @/assets/imgs/img-user-demo.png -->
            <v-img v-if="user_photo" alt="User Image" :src="user_photo" />
            <v-img
              v-else
              src="@/assets/imgs/defaultprofileimage.jpg"
              alt="Default Profile"
            />
          </v-avatar>
        </v-layout>
        <v-list-item class="pt-3">
          <v-list-item-content>
            <v-list-item-title align="center" class="title-text">{{
              user_name
            }}</v-list-item-title>
            <v-list-item-subtitle style="font-size: 16px" align="center">
              {{ position }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>

        <v-list style="padding: 0">
          <v-list-group
            v-for="item in items"
            :key="item.title"
            v-model="item.active"
            @click="!item.children ? $router.push(item.route) : ''"
            no-action
            append-icon
          >
            <template v-slot:activator>
              <v-list-item-icon v-if="item.icon === null" class="mr-0">
                <img
                  :src="require(`@/assets/imgs/${item.id}g.svg`)"
                  style="width: 20px"
                  v-if="item.active"
                  alt
                />
                <img
                  :src="require(`@/assets/imgs/${item.id}.svg`)"
                  style="width: 20px"
                  v-else
                  alt
                />
              </v-list-item-icon>
              <v-list-item-icon class="mr-0" v-else>
                <v-icon :style="item.active ? 'color: #4caf50' : ''">{{
                  item.icon
                }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="pl-3">
                  <span
                    :style="item.active ? 'color: #4caf50' : 'color: #424242'"
                    >{{ $t(item.title) }}</span
                  >
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon v-if="item.children">
                <v-icon :style="item.active ? 'color: #4caf50' : ''"
                  >mdi-chevron-right</v-icon
                >
              </v-list-item-icon>
            </template>

            <v-list-item v-for="child in item.children" :key="child.title">
              <v-list-item-content style="cursor: pointer;">
                <v-list-item-title
                  @click="toggleActive(child), (child.active = !child.active)"
                >
                  <span :style="child.active ? 'color: #4caf50' : ''">{{
                    child.title
                  }}</span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>

          <!-- <div class="hover12" v-for="(item, id) in items" :key="id">
            <figure @click="$router.push(item.route), (show = false)">
              <div style="background: white; height: 53px">
                <div
                  style="
                    background: #eaf6ea;
                    padding: 10px 20px;
                    width: 93%;
                    border-radius: 0 0 0 0;
                  "
                  v-if="$router.currentRoute.path == item.route && !show"
                >
                  <img
                    :src="require(`@/assets/imgs/${item.id}g.svg`)"
                    style="width: 20px"
                    alt
                  />
                  <span class="pl-3 b-text" style="color: #4caf50">{{
                    $t(item.title)
                  }}</span>
                </div>
                <div style="padding: 10px 20px" v-else>
                  <img
                    :src="require(`@/assets/imgs/${item.id}.svg`)"
                    style="width: 20px"
                    alt
                  />
                  <span class="pl-3 b-text">
                    {{ $t(item.title) }}
                  </span>
                </div>
              </div>
            </figure>
          </div> -->
        </v-list>
      </v-navigation-drawer>
    </nav>
    <v-content class="bg" style="padding-top: 0.45rem">
      <!-- background: #F5F5F5" -->
      <router-view />
    </v-content>

    <v-dialog v-model="logoutModal" persistent max-width="358">
      <v-card style="padding: 10px 5px 10px 0">
        <v-card-text>
          <v-layout row="wrap">
            <v-spacer />
            <v-flex
              shrink
              style="cursor: pointer"
              @click="(logoutModal = false), $router.push('/')"
            >
              <v-img
                src="@/assets/close.svg"
                aspect-ratio="1.7"
                width="13"
                height="13"
              ></v-img>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-text style="padding: 0 27px 0">
          <v-layout align-center>
            <v-flex shrink mr-5>
              <v-img
                :src="require(`@/assets/imgs/logout.png`)"
                aspect-ratio="1.7"
                width="60"
                height="60"
              ></v-img>
            </v-flex>
            <v-flex pt-3>
              <p class="alert-text">Logout successful.</p>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="#6CC8A0"
            style="color: #fff"
            @click="(logoutModal = false), $router.push('/')"
            >OK</v-btn
          >
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import GlobalMixin from "../views/Mixins/GlobalMixin";
import store from "@/store";
import enurl from "@/api/environment";
export default {
  name: "Layout",
  mixins: [GlobalMixin],
  props: {},
  mounted: function() {
    //this.getversion();
    // console.log(this.$store.getters.username);
    // console.log(this.$store.getters.userImage);
    // console.log(this.$store.getters.position);
    
    let flag = this.readCookie("flagprod");
    let lang = this.readCookie("langprod");
    let title = this.readCookie("titleprod");
    let hightlighted = this.readCookie("highlighted");
    if (flag == null) {
      this.currentflag = "us";
      this.$i18n.locale = "en";
      this.currentLangTitle = "English";
      this.lang = 1;
    } else {
      this.currentflag = flag;
      this.$i18n.locale = lang;
      this.currentLangTitle = title;
      this.lang = parseInt(hightlighted);
    }
    
    // Set active menu based on current route
    this.$nextTick(() => {
      this.updateActiveMenu();
    });
  },
  watch: {
    $route() {
      // Update active menu when route changes
      this.updateActiveMenu();
    }
  },
  data: function() {
    return {
      logoutModal: false,
      navActive: 1,
      currentflag: "us",
      drawer: null,
      lang: 1,
      current: 1,
      show: false,
      currentLangTitle: "",
      user_name: store.getters.username,
      position: store.getters.position,
      user_photo: store.getters.userImage,
      tempUrl: enurl.apiUrl,
      versiondata: [],
      images: {
        logo: require("@/assets/imgs/SeedLogo.png")
      },
      items: [
        {
          id: 6,
          title: "DashboardMenu",
          icon: null, // "mdi-account",
          route: "/dashboard/dashboardMenu",
          active: false
        },
        {
          id: 1,
          title: "companymanagement",
          icon: null, // "mdi-account",
          route: "/dashboard/companymanagement",
          active: false
        },

        {
          id: 2,
          title: "usermanagement",
          icon: null, // "mdi-account",
          route: "/dashboard/usermanagement",
          active: false
        },
        {
          id: 7,
          title: "report",
          icon: null, // "mdi-note-text",
          route: "/dashboard/report",
          active: false
        },
        {
          id: 3,
          title: "store",
          icon: null, // "mdi-cart",
          route: "/dashboard/store",
          active: false
        },
        {
          id: 4,
          title: "announcement",
          icon: null, // "mdi-note-text",
          route: "/dashboard/announcement",
          active: false
        },
        {
          id: 5,
          title: "settingmaintenance",
          icon: null, // "mdi-note-text",
          route: "/dashboard/settingmaintenance",
          active: false
        },
        {
          id: 6,
          title: "defaultcontent",
          icon: "mdi-home-variant-outline",
          active: false,
          children: [
            {
              title: "Library",
              route: "/default-content/library",
              active: false
            },
            {
              title: "Knowledge Sharing",
              route: "/default-content/knowledgesharing",
              active: false
            },
            {
              title: "Course",
              route: "/default-content/course",
              active: false
            },
            {
              title: "Banner",
              route: "/default-content/banner",
              active: false
            }
          ]
        },
        {
          id: 7,
          title: "certificatebackground",
          icon: "mdi-home-variant-outline",
          route: "/dashboard/certificatebackground",
          active: false
        }
      ],
      languages: [
        { flag: "th", language: "th", title: "ไทย", highlighted: 0 },
        { flag: "us", language: "en", title: "English", highlighted: 1 },
        { flag: "CN", language: "cn", title: "Chinese", highlighted: 2 },
        { flag: "VN", language: "vn", title: "Vietnam", highlighted: 3 },
        { flag: "MM", language: "mm", title: "Myanmar", highlighted: 4 }
      ]
    };
  },
  computed: {},
  methods: {
    updateActiveMenu() {
      // Check if route is available
      if (!this.$route || !this.$route.path) {
        return;
      }

      // Reset all items' active states first
      this.items.forEach(item => {
        item.active = false;
        if (item.children) {
          item.children.forEach(child => (child.active = false));
        }
      });

      const currentPath = this.$route.path.toLowerCase();
      
      // Find and activate the matching menu item
      this.items.forEach(item => {
        if (item.route && item.route.toLowerCase() === currentPath) {
          item.active = true;
        } else if (item.children) {
          item.children.forEach(child => {
            if (child.route && child.route.toLowerCase() === currentPath) {
              item.active = true;
              child.active = true;
            }
          });
        }
      });
    },
    
    toggleActive(child) {
      // Reset all items' active states first
      this.items.forEach(i => {
        if (i.children) {
          i.children.forEach(c => (c.active = false));
        }
      });

      // Set the clicked child or child as active
      if (!child.children) {
        this.$router.push(child.route);
      }
    },

    changeLocale(locale, flag, title, highlighted) {
      this.currentflag = flag;
      this.$i18n.locale = locale;
      this.currentLangTitle = title;
      this.lang = highlighted;
      document.cookie = "langprod=" + locale;
      document.cookie = "flagprod=" + flag;
      document.cookie = "titleprod=" + title;
      document.cookie = "highlighted=" + highlighted;
    },
    // nextPage(numUrl, pathUrl) {
    //   this.navActive = numUrl;
    //   this.$router.push(pathUrl).catch((err) => {});
    // },
    // getversion() {
    //   //Version/VersionGet
    //   //  let self = this;
    //   //   axios
    //   //     .get(`${self.tempUrl}/Version/VersionGet`)
    //   //     .then(function(response) {
    //   //       self.versiondata = response.data.data[0];
    //   //       // console.log(self.versiondata);
    //   //       // self.add_log(
    //   //       //   "-", //phonemodal
    //   //       //   "Get Version", //description
    //   //       //   "Critical", //logType
    //   //       //   "getversion", //methodName
    //   //       //   "", //exception
    //   //       //   "", //logTrace
    //   //       //   55 //correctionID
    //   //       // );
    //   //     })
    //   //     .catch(function(error) {
    //   //       self.add_log(
    //   //         "-", //phonemodal
    //   //         "Cannot Get Version Number", //description
    //   //         "Critical", //logType
    //   //         "getversion", //methodName
    //   //         error.message, //exception
    //   //         JSON.stringify(error), //logTrace
    //   //         55 //correctionID
    //   //       );
    //   //     });
    // },
    showDropdown() {
      this.navActive = 5;
      this.$router.push("/dashborad/settings");
      this.$refs.dropdowndList.style.display =
        this.$refs.dropdowndList.style.display == "block" ? "none" : "block";
    },
    logout() {
      let self = this;
      this.$store.dispatch("logout").then(function(response) {
        self.logoutModal = true;
        let expire = "Thu, 01 Jan 1970 00:00:00 GMT;";
        document.cookie = "langprod=;" + ";expires=" + expire;
        document.cookie = "flagprod=;" + ";expires=" + expire;
        document.cookie = "titleprod=;" + ";expires=" + expire;
        document.cookie = "highlighted=;" + ";expires=" + expire;
      });
      localStorage.removeItem("vivek_authenticated_admin_data");
    },
    readCookie(name) {
      let nameEQ = name + "=";
      let ca = document.cookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    }
  }
};
</script>

<style scoped>
.hover12 figure:hover div {
  cursor: pointer;
}
.v-button {
  border-radius: 28px !important ;
  cursor: pointer;
}
.appBarNavIcon {
  margin-left: 4rem;
}
@media only screen and (max-width: 600px) {
  .appBarNavIcon {
    margin-left: 0rem;
  }
}
.v-list-item:hover {
  text-decoration: none;
}

#sidebar {
  width: 15%;
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  z-index: 9;
  background-color: rgba(255, 255, 255, 1);
  color: #fff;
  transition: all 0.3s;
}
#content {
  width: 100%;
  height: 100vh;
  background-color: rgba(240, 240, 247, 1);
}

.img-user-demo {
  max-width: 90px;
  max-height: 90px;
  position: absolute;
  left: 1.5rem;
  top: 1.5rem;
}
.name-user-demo {
  max-width: 100px;
  position: absolute;
  left: 2.1rem;
  top: 130px;
}
.position-user-demo {
  max-width: 100px;
  position: absolute;
  left: 1rem;
  top: 155px;
  font-size: 10px;
  color: rgba(255, 255, 255, 0.8);
}

.bg-sildbar {
  max-width: 100%;
}

.jv-wrapper {
  display: flex;
  width: 100%;
}

.jv-slidbar-ul {
  margin: 0;
  padding: 0;
}
.jv-slidbar-ul li {
  margin: 0;
  padding: 1rem 20px 1rem 0;
  padding-left: 1.5rem;
  font-size: 14px;
  color: rgba(67, 66, 93, 1);
  list-style: none;
}
.jv-slidbar-ul li:hover {
  cursor: pointer;
}
.jv-slidbar-ul li i {
  color: #13322c;
}
.jv-slidbar-ul li.active {
  padding-left: 1.3rem;
  border-left: 5px solid #13322c;
  background-color: #e8ebea;
}
.jv-slidbar-ul li a {
  font-size: 14px;
  color: rgba(67, 66, 93, 1);
  text-decoration: none;
}

.slidbar-dropdown-list {
  margin-top: 20px;
  display: none;
}

.jv-navbar {
  padding: 10px 35px;
  background-color: rgba(255, 255, 255, 1) !important;
}

.nav-cont {
  position: absolute;
  z-index: 2;
  padding-top: 22vh;
  width: 100%;
}

@media (min-width: 1401px) and (max-width: 1870px) {
  #sidebar {
    width: 250px;
  }
}

@media (max-width: 1400px) {
  .nav-cont {
    padding-top: 30vh;
  }
}
.flagIcon {
  font-size: 20px;
}
.menubar {
  padding-right: 3.5rem !important;
}

@media (min-width: 900px) and (max-width: 1399px) {
  #sidebar {
    width: 300px;
  }
}
@media (min-height: 400px) and (max-height: 599px) {
  .jv-slidbar-ul {
    margin-top: 100px;
  }
}

@media (min-height: 600px) and (max-height: 800px) {
  #sidebar {
    height: 100vh;
  }
  #content {
    width: 100%;
    height: 1000px;
    background-color: rgba(240, 240, 247, 1);
  }
  .jv-slidbar-ul {
    margin-top: 50px;
  }
}

@media (min-height: 801px) and (max-height: 1024px) {
  .jv-slidbar-ul {
    margin-top: 15%;
  }
}
@media (min-width: 1264px) {
  .menu_icon {
    display: none;
  }
}
</style>

<style>
.active2
  .v-list-group__header.v-list-item.v-list-item--active.v-list-item--link.theme--light.green--text {
  background: #eaf6ea;
  border-radius: 0px 25px 25px 0px !important;
  width: 230px;
}
/* .v-list-group__header.v-list-item.v-list-item--link.theme--light {
  width: 230px;
} */
.bg {
  background: url("~@/assets/imgs/Component 87 – 98.png") no-repeat center
    center;
  background-size: cover;
  object-fit: contain;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: #ffffff;
  transform: scale(1);
}
</style>
